
const headers = [
    {
      label: 'ครั้งที่ประชุม',
      field: 'cNumber',
    },
    {
      label: 'จำนวนผู้ประกอบการ',
      field: 'companies',
      tdClass: 'text-center',
    },
    {
      label: 'วันที่ประชุม',
      field: 'cDate',
      tdClass: 'text-center',
    },
    {
      label: 'มติที่ประชุม',
      field: 'details',      
    },
    {
      label: 'จัดการ',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers